<template>
  <BlFlexContainerMv direction="row" align-items="center" justify-content="flex-start" wrap="wrap">
    <BlFlexItemAv v-for="i in count" :key="i" class="w-[25%] h-[84px] qa-shimmer-list-with-icon">
      <BlFlexContainerMv direction="column" align-items="center">
        <BlShimmerAv width="40px" height="40px" class="inline-block overflow-hidden" style="border-radius: 50%"></BlShimmerAv>
        <BlShimmerAv width="56px" height="8px" class="inline-block mt-8 rounded"></BlShimmerAv>
      </BlFlexContainerMv>
    </BlFlexItemAv>
  </BlFlexContainerMv>
</template>

<script>
import {BlShimmerAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'ListWithIconShimmer',
  components: {
    BlShimmerAv,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
};
</script>
